import React, { Component } from 'react';
import { Button, ButtonToolbar, Col, Tabs, Tab } from 'react-bootstrap';
import Toggle from 'react-toggle'

import { PropTypes } from 'prop-types';
import { PathStopsActive } from './PathStopsActive';
import { PathStopActiveForm } from './PathStopActiveForm';
import { PathStopsDraft } from './PathStopsDraft';
import { PathStopDraftForm } from './PathStopDraftForm';
import { StopsCommand } from '../commands/StopsCommand';
import { LinesCommand } from '../commands/LinesCommand';
import { PathsCommand } from '../commands/PathsCommand';
import { PathStopsCommand } from '../commands/PathStopsCommand';
import { StopsDraftCommand } from '../commands/StopsDraftCommand';
import { LinesDraftCommand } from '../commands/LinesDraftCommand';
import { PathsDraftCommand } from '../commands/PathsDraftCommand';
import { PathStopsDraftCommand } from '../commands/PathStopsDraftCommand';
import { EditionSelector } from '../../EditionSelector';
import { TitleRow } from '../../TitleRow';
import { LoadingSpinner } from '../../LoadingSpinner';
import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';
import { ComparisonHelper } from '../../helpers/ComparisonHelper';
import { RegionsCommand } from '../commands/RegionsCommand';

export class PathStops extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string,
        edition: PropTypes.object,
        addEditionObserver: PropTypes.func,
        removeEditionObserver: PropTypes.func
    }

    constructor(props) {
        super(props);
        this.state = {
            data: {
                active: {
                    regions: [],
                    stops: [],
                    lines: [],
                    paths: [],
                    pathStops: []
                },
                draft: {
                    regions: [],
                    stops: [],
                    lines: [],
                    paths: [],
                    pathStops: []
                }
            },
            form: {
                active: {
                    line: undefined,
                    path: undefined,
                    pathStop: undefined
                },
                draft: {
                    line: undefined,
                    path: undefined,
                    pathStop: undefined
                },
                order: {
                    active: false,
                    draft: false
                }
            },
            render: {
                tab: "active",
                compare: false,
                filter: ""
            },
            actions: {
                active: {
                    isLoadingStops: true,
                    isLoadingLines: true,
                    isLoadingPaths: false,
                    isLoadingRegions: false,
                    isLoadingPathStops: false,
                    isUpdatingPathStop: false,
                    isDeletingPathStop: false,
                },
                draft: {
                    isLoadingStops: true,
                    isLoadingLines: true,
                    isLoadingPaths: false,
                    isLoadingRegions: false,
                    isLoadingPathStops: false,
                    isUpdatingPathStop: false,
                    isDeletingPathStop: false,
                },
                isLoadingEditions: false,
            },
            commands: {
                active: {
                    stops: new StopsCommand(),
                    lines: new LinesCommand(),
                    paths: new PathsCommand(),
                    pathStops: new PathStopsCommand()
                },
                draft: {
                    stops: new StopsDraftCommand(),
                    lines: new LinesDraftCommand(),
                    paths: new PathsDraftCommand(),
                    pathStops: new PathStopsDraftCommand()
                },
                regions: new RegionsCommand()
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        }
    }

    componentDidMount() {
        this.context.selectApp('datamanager', false);
        this.context.addEditionObserver(this);
    }

    componentWillUnmount() {
        this.context.removeEditionObserver(this);
    }

    // ----------------------

    startUpdate() {
        const { actions } = this.state;

        actions.isLoadingEditions = true;

        this.setState({
            actions: actions
        });
    }

    endUpdate() {
        const { actions } = this.state;

        actions.isLoadingEditions = false;

        this.setState({
            actions: actions
        });
    }

    updateNetwork() {
        const { actions } = this.state;

        actions.active.isLoadingLines = true;
        actions.active.isLoadingStops = true;

        this.setState({
            actions: actions
        }, () => {
            const { edition } = this.context;

            this.getLines(edition, "active");
            this.getStops(edition, "active");
        });
    }

    updateDraftNetwork() {
        const { actions } = this.state;

        actions.draft.isLoadingLines = true;
        actions.draft.isLoadingStops = true;

        this.setState({
            actions: actions
        }, () => {
            const { edition } = this.context;

            this.getLines(edition, "draft");
            this.getStops(edition, "draft");
        });
    }

    // ----------------------

    listSuccessCallback(result, dataType, updateData, updateAction, callback) {
        const { data, actions } = this.state;

        actions[dataType][updateAction] = false;
        data[dataType][updateData] = result;

        // Update data
        this.setState({
            data: data,
            actions: actions
        }, () => {
            if ("function" === typeof (callback)) {
                callback();
            }
        });
    }

    listErrorCallback(messageReceived, dataType, updateData, updateAction) {
        const { data, actions, message } = this.state;

        actions[dataType][updateAction] = false;
        data[dataType][updateData] = [];

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            data: data,
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    operationSuccessCallback(result, updateAction, dataType, callback) {
        const { actions, message } = this.state;

        actions[dataType][updateAction] = false;

        if (message.show) {
            result.message = `${message.message}\n${result.message}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: result.message,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        if ("function" === typeof callback) {
            callback(result.data);
        }
    }

    operationErrorCallback(messageReceived, updateAction, dataType, callback) {
        const { actions, message } = this.state;

        actions[dataType][updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });

        if ("function" === typeof callback) {
            callback();
        }
    }

    // ----------------------

    getStops(edition, dataType) {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { commands } = this.state;

        commands[dataType].stops.get(
            edition,
            selectedProviderId,
            false,
            (a) => this.listSuccessCallback(a, dataType, "stops", "isLoadingStops"),
            (a) => this.listErrorCallback(a, dataType, "stops", "isLoadingStops")
        );
    }

    getLines(edition, dataType) {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { commands, actions } = this.state;

        actions[dataType].isLoadingLines = true;
        commands[dataType].lines.get(
            edition,
            selectedProviderId,
            (a) => this.listSuccessCallback(a, dataType, "lines", "isLoadingLines", () => this.updateForm(dataType, "line")),
            (a) => this.listErrorCallback(a, dataType, "lines", "isLoadingLines")
        );

        this.setState({
            actions: actions
        });
    }

    updateForm(dataType, type) {
        const { data, form } = this.state;
        const { active } = form;

        if ("draft" !== dataType && active[type] !== undefined) {

            if ("line" === type) {

                this.onChangeLine(data.active.lines.find(x => x.code === active.line.code), dataType, false);
            }
            else if ("path" === type) {

                this.onChangePath(data.active.paths.find(x => x.code === active.path.code), dataType);
            }
        }
    }

    getPaths(edition, line, dataType) {
        let selectedProviderId = "";
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { commands, actions } = this.state;

        actions[dataType].isLoadingPaths = true;
        commands[dataType].paths.getByLine(
            edition,
            line.id,
            selectedProviderId,
            (a) => this.listSuccessCallback(a, dataType, "paths", "isLoadingPaths", () => this.updateForm(dataType, "path")),
            (a) => this.listErrorCallback(a, dataType, "paths", "isLoadingPaths")
        );

        this.setState({
            actions: actions
        });
    }

    getRegions(edition, line, dataType) {
        let selectedProviderId = "";
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { commands, actions } = this.state;

        actions[dataType].isLoadingRegions = true;
        commands.regions.getByLine(
            "active" === dataType ? edition.network : edition.draftNetwork,
            line.id,
            selectedProviderId,
            (a) => this.listSuccessCallback(a, dataType, "regions", "isLoadingRegions"),
            (a) => this.listErrorCallback(a, dataType, "regions", "isLoadingRegions")
        );

        this.setState({
            actions: actions
        });
    }

    getPathStops(edition, path, dataType) {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { commands, actions } = this.state;

        actions[dataType].isLoadingPathStops = true;
        commands[dataType].pathStops.getByPath(
            edition,
            path.id,
            selectedProviderId,
            (a) => this.listSuccessCallback(a, dataType, "pathStops", "isLoadingPathStops", () => this.sortPathStopsList(dataType)),
            (a) => this.listErrorCallback(a, dataType, "pathStops", "isLoadingPathStops")
        );

        this.setState({
            actions: actions
        });
    }

    // ----------------------

    onChangeLine(line, dataType, updatePathForm = true) {
        const { edition } = this.context;
        const { form } = this.state;

        form[dataType].line = line;
        if (updatePathForm) {
            form[dataType].path = undefined;
        }

        this.setState({
            form: form
        });

        if (null !== line && undefined !== line) {
            this.getPaths(edition, line, dataType);
            this.getRegions(edition, line, dataType);
        }
        else {
            const { data } = this.state;

            data[dataType].paths = [];

            this.setState({
                data: data
            });
        }
    }

    onChangePath(path, dataType) {
        const { edition } = this.context;
        const { form } = this.state;

        form[dataType].path = path;

        this.setState({
            form: form
        });

        if (null !== path && undefined !== path) {
            this.getPathStops(edition, path, dataType);
        }
        else {
            const { data } = this.state;

            data[dataType].pathStops = [];

            this.setState({
                data: data
            });
        }
    }

    onDragOver(e) {
        e.preventDefault();
    };

    onDragStart(e, idx) {
        e.dataTransfer.setData('index', idx);
    };

    onDrop(e, dataType) {
        const oldIndex = e.dataTransfer.getData('index');
        const newIndex = e.target.dataset.value;

        if (oldIndex !== undefined && newIndex !== undefined) {
            const { form, data } = this.state;

            const maxOrder = Math.max(...data[dataType].pathStops.map(pathStop => pathStop.stopOrder), 0) + 1;

            if (newIndex >= maxOrder) {
                var k = newIndex - maxOrder + 1;
                while (k--) {
                    data[dataType].pathStops.push(undefined);
                }
            }

            data[dataType].pathStops.splice(newIndex, 0, data[dataType].pathStops.splice(oldIndex, 1)[0]);
            data[dataType].pathStops.forEach((pathStop, i) => {
                pathStop.stopOrder = i + 1;
            });
            form.order[dataType] = true;

            this.setState({
                data: data,
                form: form
            });
        }
    }

    onChangeValue(e, value, dataType) {
        const { form } = this.state;

        form[dataType].pathStop.obj[value] = e.target.value;

        this.setState({
            form: form,
        });
    }

    onSelectValue(e, value, dataType) {
        const { form } = this.state;

        form[dataType].pathStop.obj[value] = e;

        this.setState({
            form: form,
        });
    }

    onCheckValue(e, value, dataType) {
        const { form } = this.state;

        form[dataType].pathStop.obj[value] = e.target.checked;

        this.setState({
            form: form,
        });
    }

    onSavePathStopSpine(pathStop, isInSpine, callback, dataType) {
        const { edition } = this.context;
        const { commands } = this.state;

        if ("function" === typeof callback) {
            commands[dataType].pathStops.updateSpine(
                edition,
                pathStop.id,
                isInSpine,
                () => this.saveSpineSuccessCallback(pathStop, isInSpine, "isUpdating", dataType, () => callback()),
                (a) => this.operationErrorCallback(a, "isUpdating", dataType, () => callback())
            );
        }
    }

    saveSpineSuccessCallback(pathStop, isInSpine, updateAction, dataType, callback) {
        const { actions } = this.state;
        actions[dataType][updateAction] = false;

        pathStop.inSpine = isInSpine;

        this.setState({
            actions: actions,
        });

        if ("function" === typeof callback) {
            callback();
        }
    }

    onSavePathStop(dataType) {
        if (!this.isValidInput(dataType)) {
            return null;
        }

        const { edition } = this.context;
        const { form, commands, actions } = this.state;

        actions[dataType].isUpdatingPathStop = true;

        commands[dataType].pathStops.save(
            edition,
            form[dataType].pathStop.obj,
            (a) => this.operationSuccessCallback(a, "isUpdatingPathStop", dataType, () => this.getPathStops(edition, form[dataType].path, dataType)),
            (a) => this.operationErrorCallback(a, "isUpdatingPathStop", dataType)
        );

        this.setState({
            actions: actions
        });

        this.onFormExit(dataType);
    }

    onSaveChangesClick(dataType) {
        const { edition } = this.context;
        const { data, form } = this.state;

        if (0 < data[dataType].pathStops.length && form.order[dataType]) {
            const { commands, actions } = this.state;

            commands[dataType].pathStops.updateInBulk(
                edition,
                data[dataType].pathStops,
                (a) => this.operationSuccessCallback(a, "isUpdatingPathStop", dataType, () => this.getPathStops(edition, form[dataType].path, dataType)),
                (a) => this.operationErrorCallback(a, "isUpdatingPathStop", dataType, () => this.onSaveChangesError(dataType))
            );

            form.order[dataType] = false;
            actions[dataType].isUpdatingPathStop = true;

            this.setState({
                form: form,
                actions: actions
            });
        }
    }

    onSaveChangesError(dataType) {
        const { form } = this.state;

        form.order[dataType] = true;

        this.setState({
            form: form
        });
    }

    onCreateClick(dataType) {
        const { form } = this.state;

        if (undefined === form[dataType].line || null === form[dataType].line) {
            this.setState({
                message: {
                    show: true,
                    message: "Selecione uma linha",
                    style: "warning",
                    title: "Aviso",
                    icon: "alert"
                }
            });
        }
        else if (undefined === form[dataType].path || null === form[dataType].path) {
            this.setState({
                message: {
                    show: true,
                    message: "Selecione um percurso",
                    style: "warning",
                    title: "Aviso",
                    icon: "alert"
                }
            });
        }
        else {
            const { data } = this.state;

            form[dataType].pathStop = {
                title: "Criar",
                original: undefined,
                obj: {
                    networkEdition: form[dataType].path.networkEdition,
                    path: form[dataType].path,
                    pathId: form[dataType].path.id,
                    prevDistance: "",
                    segmentBreakDuration: "",
                    duration: "",
                    stopOrder: Math.max(...data[dataType].pathStops.map(pathStop => pathStop.stopOrder), 0) + 1,
                    inSpine: false
                },
                durationInputError: null,
                distanceInputError: null,
                stopInputError: null,
            };

            this.setState({
                form: form
            });
        }
    }

    onEditClick(pathStop, dataType) {
        const { form, data, render } = this.state;

        if (render.compare) {
            pathStop = data[dataType].pathStops.find(unmutedPathStop => unmutedPathStop.id === pathStop.id);
        }

        form[dataType].pathStop = {
            title: "Editar",
            original: pathStop,
            obj: Object.assign({
                networkEdition: form[dataType].path.networkEdition,
                path: form[dataType].path,
                pathId: form[dataType].path.id,
                prevDistance: "",
                segmentBreakDuration: "",
                duration: "",
                stopOrder: data[dataType].pathStops.length,
                inSpine: false
            }, pathStop),
            durationInputError: null,
            distanceInputError: null,
            stopInputError: null,
        };

        this.setState({
            form: form
        });
    }

    onDeleteClick(pathStop, dataType) {
        const { form } = this.state;

        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: `Tem a certeza que pretende eliminar a Paragem ${undefined === pathStop.stop ? pathStop.stopName : pathStop.stop.name} do percurso "${form[dataType].path.code}"`,
                style: "warning",
                icon: "alert",
                argument: {
                    id: pathStop.id,
                    dataType: dataType
                }
            }
        });
    }

    onFormExit(dataType) {
        const { form } = this.state;

        form[dataType].pathStop = undefined;

        this.setState({
            form: form
        });
    }

    onSelectTab(key) {
        const { render } = this.state;

        render.tab = key;

        this.setState({
            render: render
        });
    }

    onToggleIsComparing() {
        const { render } = this.state;

        render.compare = !render.compare;

        this.setState({
            render: render
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    onExitDialog(isToExecute, argument) {
        const { actions } = this.state;

        if (isToExecute) {
            const { edition } = this.context;
            const { form, commands } = this.state;

            commands[argument.dataType].pathStops.delete(
                edition,
                argument.id,
                (a) => this.operationSuccessCallback(a, "isDeletingPathStop", argument.dataType, () => this.getPathStops(edition, form[argument.dataType].path, argument.dataType)),
                (a) => this.operationErrorCallback(a, "isDeletingPathStop", argument.dataType)
            );

            actions[argument.dataType].isDeletingPathStop = true;
        }

        this.setState({
            actions: actions,
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    }

    // ----------------------

    isValidInput(dataType) {
        const { form } = this.state;
        let errors = 0;

        if (
            (
                (isNaN(form[dataType].pathStop.obj.segmentBreakDuration) && form[dataType].pathStop.obj.segmentBreakDuration < 0) || "" === form[dataType].pathStop.obj.segmentBreakDuration
            ) &&
            (
                (isNaN(form[dataType].pathStop.obj.duration) && form[dataType].pathStop.obj.duration < 0) || "" === form[dataType].pathStop.obj.duration
            )
        ) {
            form[dataType].pathStop.durationInputError = "error";
            errors++;
        }

        if ((isNaN(form[dataType].pathStop.obj.prevDistance) && form[dataType].pathStop.obj.prevDistance < 0) || "" === form[dataType].pathStop.obj.prevDistance) {
            form[dataType].pathStop.distanceInputError = "error";
            errors++;
        }

        if (
            (undefined === form[dataType].pathStop.obj.stop || null === form[dataType].pathStop.obj.stop || "" === form[dataType].pathStop.obj.stop || 0 === form[dataType].pathStop.obj.stop.id) &&
            (undefined === form[dataType].pathStop.obj.stop && (undefined === form[dataType].pathStop.obj.stopId || null === form[dataType].pathStop.obj.stopId || "" === form[dataType].pathStop.obj.stopId || 0 === form[dataType].pathStop.obj.stopId))
        ) {
            form[dataType].pathStop.stopInputError = "error";
            errors++;
        }

        this.setState({
            form: form
        });

        return 0 === errors;
    }

    sortPathStopsList(dataType) {
        const { data } = this.state;

        data[dataType].pathStops.sort((a, b) => this.sortPathStops(a, b));

        this.setState({
            data: data
        });
    }

    sortPathStops(a, b) {
        let aStopOrder = a.stopOrder;
        let bStopOrder = b.stopOrder;

        if ("object" === typeof aStopOrder) {
            aStopOrder = undefined !== aStopOrder.left ? aStopOrder.left : aStopOrder.right;
        }

        if ("object" === typeof bStopOrder) {
            bStopOrder = undefined !== bStopOrder.left ? bStopOrder.left : bStopOrder.right;
        }

        return aStopOrder !== bStopOrder ? aStopOrder < bStopOrder ? -1 : 1 : 0;
    }

    parseRegionsValue(regions) {
        if (!Array.isArray(regions)) {
            return undefined;
        }

        return regions.map(region => region.name).sort().join(",");
    }

    // ----------------------

    renderActiveForm() {
        const { form } = this.state;

        if (undefined === form.active.pathStop) {
            return null;
        }

        const { data } = this.state;

        return (
            <PathStopActiveForm show={true}
                form={form.active.pathStop}
                line={form.active.line}
                path={form.active.path}
                stops={data.active.stops}
                regions={data.active.regions}
                onChangeValue={(a, b) => this.onChangeValue(a, b, "active")}
                onSelectValue={(a, b) => this.onSelectValue(a, b, "active")}
                onCheckValue={(a, b) => this.onCheckValue(a, b, "active")}
                onSave={() => this.onSavePathStop("active")}
                onHide={() => this.onFormExit("active")} />
        );
    }

    renderDraftForm() {
        const { form } = this.state;

        if (undefined === form.draft.pathStop) {
            return null;
        }

        const { data } = this.state;

        return (
            <PathStopDraftForm show={true}
                form={form.draft.pathStop}
                line={form.draft.line}
                path={form.draft.path}
                stops={data.draft.stops.filter(stop => stop.networkEdition === form.draft.line.networkEdition)}
                regions={data.draft.regions}
                onChangeValue={(a, b) => this.onChangeValue(a, b, "draft")}
                onSelectValue={(a, b) => this.onSelectValue(a, b, "draft")}
                onCheckValue={(a, b) => this.onCheckValue(a, b, "draft")}
                onSave={() => this.onSavePathStop("draft")}
                onHide={() => this.onFormExit("draft")} />
        );
    }

    renderPathsActive() {
        const { data, form, render, actions } = this.state;

        if (actions.active.isLoadingLines) {
            return (<LoadingSpinner />)
        }

        let pathStopsToRender = data.active.pathStops;
        if (render.compare) {
            const draftPathStops = data.draft.pathStops;

            pathStopsToRender = ComparisonHelper.compare(
                pathStopsToRender,
                (undefined === form.active.line || undefined === form.active.path) ? [] : draftPathStops.filter(dps => dps.lineCode === form.active.line.code && dps.pathCode === form.active.path.code),
                {
                    match: [{ left: "stopOrder", right: "stopOrder" }],
                    fields: [
                        { left: "segmentBreakDuration", right: "duration" },
                        { left: "stop.name", right: "stopName" },
                        { left: "stop.code", right: "stopCode" },
                        { left: "stop.shortName", right: "stopShortName" },
                        { left: "regions", right: "regions", leftParser: (a) => this.parseRegionsValue(a), rightParser: (a) => this.parseRegionsValue(a) }]
                });
        }

        return (
            <PathStopsActive lines={data.active.lines}
                paths={data.active.paths}
                pathStops={pathStopsToRender}
                lineSelected={form.active.line}
                pathSelected={form.active.path}
                isLoadingPaths={actions.active.isLoadingPaths}
                isLoadingPathStops={actions.active.isLoadingPathStops}
                isComparing={render.compare}
                onDrop={(a) => this.onDrop(a, "active")}
                onDragStart={(a, b) => this.onDragStart(a, b)}
                onDragOver={(a) => this.onDragOver(a)}
                onChangeLine={(a) => this.onChangeLine(a, "active")}
                onChangePath={(a) => this.onChangePath(a, "active")}
                onEditClick={(a) => this.onEditClick(a, "active")}
                onDeleteClick={(a) => this.onDeleteClick(a, "active")}
                onSavePathStopSpine={(a, b, c) => this.onSavePathStopSpine(a, b, c, "active")} />
        );
    }

    renderPathsDraft() {
        const { data, form, actions } = this.state;

        if (actions.draft.isLoadingLines) {
            return (<LoadingSpinner />)
        }

        return (
            <PathStopsDraft lines={data.draft.lines}
                paths={data.draft.paths}
                pathStops={data.draft.pathStops}
                lineSelected={form.draft.line}
                pathSelected={form.draft.path}
                isLoadingPaths={actions.draft.isLoadingPaths}
                isLoadingPathStops={actions.draft.isLoadingPathStops}
                onDrop={(a) => this.onDrop(a, "draft")}
                onDragStart={(a, b) => this.onDragStart(a, b)}
                onDragOver={(a) => this.onDragOver(a)}
                onChangeLine={(a) => this.onChangeLine(a, "draft")}
                onChangePath={(a) => this.onChangePath(a, "draft")}
                onEditClick={(a) => this.onEditClick(a, "draft")}
                onDeleteClick={(a) => this.onDeleteClick(a, "draft")}
                onSavePathStopSpine={(a, b, c) => this.onSavePathStopSpine(a, b, c, "draft")} />
        );
    }

    renderTabOptions(render) {
        if ("active" === render.tab) {
            return (
                <div className="tab-options">
                    <label>
                        <Toggle className="comparison-toggle"
                            checked={render.compare}
                            icons={false}
                            onChange={() => this.onToggleIsComparing()} />
                        <span>COMPARAR</span>
                    </label>
                </div>
            );
        }

        return null;
    }

    renderTabs() {
        const { render } = this.state;

        return (
            <div className="tab-with-options">
                <Tabs id="datamanager_tabs" activeKey={render.tab} onSelect={(a) => this.onSelectTab(a)}>
                    <Tab eventKey="active" key="active" title="Rede Ativa">
                        {this.renderPathsActive()}
                    </Tab>
                    <Tab eventKey="draft" key="draft" title="Rascunho">
                        {this.renderPathsDraft()}
                    </Tab>
                </Tabs>
                {this.renderTabOptions(render)}
            </div>
        );
    }

    renderButtons() {
        const { render, form } = this.state;

        return (
            <ButtonToolbar className="pull-right title-row-col-btns">
                <Button disabled={!form.order[render.tab]} onClick={() => this.onSaveChangesClick(render.tab)}>GUARDAR ALTERAÇÕES</Button>
                <Button onClick={() => this.onCreateClick(render.tab)}>CRIAR</Button>
            </ButtonToolbar>
        );
    }

    renderOperationFeedback(text, isExecuting) {
        return (
            <HandleMessage
                title={text}
                message={<LoadingSpinner />}
                style={`primary`}
                icon="transfer"
                show={isExecuting}
                small
                noButtons />
        );
    }

    render() {
        const { actions, message, dialog } = this.state;

        return (
            <div>
                <EditionSelector />

                <div>
                    <TitleRow title="Paragens por Percurso" showSeparator={true}>
                        <Col className="padding-0" xs={12} sm={12} md={12}>
                            {this.renderButtons()}
                        </Col>
                    </TitleRow>

                    <div className="margin-top-15">
                        {this.renderTabs()}
                    </div>
                </div>

                {this.renderActiveForm()}
                {this.renderDraftForm()}

                {
                    this.renderOperationFeedback(
                        "A Executar...",
                        actions.active.isUpdatingPathStop || actions.active.isDeletingPathStop || actions.draft.isUpdatingPathStop || actions.draft.isDeletingPathStop
                    )
                }
                {this.renderOperationFeedback("A Carregar Edição...", actions.isLoadingEditions)}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />

                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/pathStops/PathStops.js